import dayjs, { Dayjs } from 'dayjs'

export const seniorityInDays = (fieldSince: string): number => {
  const currentDate: Dayjs = dayjs(Date.now())
  const createdDate: Dayjs = dayjs(fieldSince)
  return currentDate.diff(createdDate, 'days')
}
